module.exports = __webpack_public_path__ + "img/icn-lc.291a5f1e.png";